import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FcApproval } from 'react-icons/fc';
import { EscolaContext } from '../../contexts/escola';

export default function ConfAgendamento() {
  const { alunoC, maeAluno, CPFAluno } = useContext(EscolaContext);

  return (
    <div className="flex flex-col py-3 px-10">
      <div className="flex-col p-9 flex items-center justify-center">
        <div className="flex-wrap text-center text-letras2 font-loto font-extrabold text-xl uppercase pb-5">
          <h1>Agendamento realizado com sucesso</h1>
          <FcApproval />
        </div>

        <div className="w-full max-w-md">
          <h2 className="font-abc font-bold text-letras2 text-lg">Aluno: {alunoC}</h2>
          <h2 className="font-abc font-bold text-letras2 text-lg">Nome da Mãe: {maeAluno}</h2>
          <h2 className="font-abc font-bold text-letras2 text-lg">CPF: {CPFAluno}</h2>
          <p className="mt-4 text-sm text-gray-600">
            O protocolo é baixado automaticamente quando o sistema confirma o atendimento.
          </p>
        </div>

        <div className="flex justify-center py-10">
          <Link to={'/'}>
            <button className="rounded-full p-1 w-full sm:w-56 bg-green hover:bg-letras2 hover:text-2 cursor-pointer text-white text-lg font-semibold">
              Voltar para o início
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
